// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';

/**
 * Reads a stored file by its key as text, for callers that need the contents in
 * the page rather than saved to disk. Use `downloadFileByKey` to save it.
 */
export async function getFileText(fileKey: string): Promise<string> {
  const response = await api.get<string>(`/v1/file/${fileKey}`, {
    responseType: 'text',
  });

  return response.data;
}
